import { AxiosResponse } from 'axios'

import { Repository } from 'ecp/repositories/Repository'
import nexusApi from 'services/nexusApi'

class S3Repository extends Repository {
  async getImage (s3Url: string): Promise<Blob> {
    const config = {
      params: {
        url: s3Url
      },
      responseType: 'blob' as const
    }

    const response: AxiosResponse<Blob> = await this.api.get(this.path, config)
    return response.data
  }
}

export default new S3Repository({
  path: '/auth/line-aws-s3',
  api: nexusApi
})
